export function ApiResource(resourcePath) {
    return function (constructor) {
        return class extends constructor {
            constructor(...args) {
                super(resourcePath);
                this.resourcePath = resourcePath;
            }
        };
    };
}
